export const COLORS = {
    BLUE: '#446DB4',
    WHITE: '#FFFFFF',
    BLACK: '#000000',
}
